var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-info"},[_c('h1',[_vm._v("个人信息")]),_c('p',[_c('strong',[_vm._v("姓名：")]),_vm._v(_vm._s(_vm.name))]),_c('p',[_c('strong',[_vm._v("年龄：")]),_vm._v(_vm._s(_vm.age))]),_c('p',[_c('strong',[_vm._v("邮箱：")]),_vm._v(_vm._s(_vm.email))]),_c('p',[_c('strong',[_vm._v("地址：")]),_vm._v(_vm._s(_vm.address))])])
}
var staticRenderFns = []

export { render, staticRenderFns }